'use strict';

var toPropertyKey = require('./toPropertyKey.js');

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

module.exports = _defineProperty;
//# sourceMappingURL=defineProperty.js.map
